(function () {
  if (window.__sideCartEnhancementsBound) return;
  window.__sideCartEnhancementsBound = true;

  function getCartDrawer() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function getAddUrl() {
    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
    if (!/\.js$/.test(addUrl)) addUrl += '.js';
    return addUrl;
  }

  function openCartWithPayload(payload) {
    var cartDrawer = getCartDrawer();
    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      if (cartDrawer.classList.contains('is-empty')) {
        cartDrawer.classList.remove('is-empty');
      }
      cartDrawer.renderContents(payload);
    } else {
      window.location = (window.routes && window.routes.cart_url) || '/cart';
    }
  }

  function appendSections(payloadOrFormData, isFormData) {
    var cartDrawer = getCartDrawer();
    if (!cartDrawer || typeof cartDrawer.getSectionsToRender !== 'function') return;

    var sectionIds = cartDrawer.getSectionsToRender().map(function (section) {
      return section.id;
    });

    if (isFormData) {
      payloadOrFormData.append('sections', sectionIds);
      payloadOrFormData.append('sections_url', window.location.pathname);
    } else {
      payloadOrFormData.sections = sectionIds.join(',');
      payloadOrFormData.sections_url = window.location.pathname;
    }

    if (typeof cartDrawer.setActiveElement === 'function') {
      cartDrawer.setActiveElement(document.activeElement);
    }
  }

  function parseKitRoot(form) {
    if (!form) return null;
    if (form.matches && form.matches('[data-kit-fixed]')) return form;
    return form.querySelector('[data-kit-fixed]');
  }

  function addFixedKit(form, button) {
    var kitRoot = parseKitRoot(form);
    if (!kitRoot) return false;

    var kitItems = [];
    try {
      kitItems = JSON.parse(kitRoot.getAttribute('data-kit-items') || '[]');
    } catch (err) {
      kitItems = [];
    }
    if (!kitItems.length) return true;

    if (button && button.getAttribute('aria-disabled') === 'true') return true;

    var originalHtml = button ? button.innerHTML : '';
    if (button) {
      button.setAttribute('aria-disabled', 'true');
      button.innerHTML = 'Adicionando...';
    }

    var qtyField = form.querySelector('[name="quantity"]');
    var kitQty = parseInt(qtyField && qtyField.value, 10);
    if (isNaN(kitQty) || kitQty < 1) kitQty = 1;

    var payload = {
      items: kitItems.map(function (item) {
        return {
          id: Number(item.id),
          quantity: Math.max(1, Number(item.quantity) || 1) * kitQty,
          properties: {
            _sidekit: '1',
            _sidekit_title: kitRoot.getAttribute('data-kit-title') || '',
            _sidekit_flavor: item.title || '',
            _sidekit_url: kitRoot.getAttribute('data-kit-url') || '',
            _sidekit_handle: kitRoot.getAttribute('data-kit-handle') || '',
          },
        };
      }),
    };
    appendSections(payload, false);

    fetch(getAddUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(payload),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (payloadResponse) {
        if (button) {
          button.innerHTML = originalHtml;
          button.removeAttribute('aria-disabled');
        }
        if (payloadResponse.status && (payloadResponse.description || payloadResponse.message)) {
          return;
        }
        openCartWithPayload(payloadResponse);
      })
      .catch(function () {
        if (button) {
          button.innerHTML = originalHtml;
          button.removeAttribute('aria-disabled');
        }
      });

    return true;
  }

  function addToCartViaForm(form, button) {
    if (!form || (button && button.getAttribute('aria-disabled') === 'true')) return;
    if (addFixedKit(form, button)) return;

    var originalHtml = button ? button.innerHTML : '';
    if (button) {
      button.setAttribute('aria-disabled', 'true');
      button.innerHTML = 'Adicionando...';
    }

    var formData = new FormData(form);
    appendSections(formData, true);

    fetch(getAddUrl(), {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: formData,
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (payload) {
        if (button) {
          button.innerHTML = originalHtml;
          button.removeAttribute('aria-disabled');
        }

        if (payload.status && (payload.description || payload.message)) {
          return;
        }

        openCartWithPayload(payload);
      })
      .catch(function () {
        if (button) {
          button.innerHTML = originalHtml;
          button.removeAttribute('aria-disabled');
        }
        form.submit();
      });
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) {
        form = event.target.closest('form');
      }
      if (!form) return;

      var isUpsell = form.matches('form.side-cart-upsell__form, form.side-combina-form');
      var isFixedKit = !!parseKitRoot(form) && !form.closest('product-form');
      if (!isUpsell && !isFixedKit) return;

      event.preventDefault();
      event.stopPropagation();
      addToCartViaForm(form, form.querySelector('[type="submit"]'));
    },
    true
  );

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-sidekit-remove]');
    if (!button) return;
    event.preventDefault();

    var keys = (button.getAttribute('data-sidekit-keys') || '')
      .split(',')
      .map(function (key) {
        return key.trim();
      })
      .filter(Boolean);
    if (!keys.length) return;

    var cartItems = button.closest('cart-drawer-items');
    var cartDrawer = getCartDrawer();
    var updates = {};
    keys.forEach(function (key) {
      updates[key] = 0;
    });

    button.setAttribute('aria-disabled', 'true');
    var row = button.closest('tr.sidekit-cart-group');
    var spinner = row ? row.querySelector('.loading__spinner') : null;
    if (spinner) spinner.classList.remove('hidden');

    var sections =
      cartItems && typeof cartItems.getSectionsToRender === 'function'
        ? cartItems.getSectionsToRender()
        : [
            { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' },
            { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
          ];

    fetch((window.routes && window.routes.cart_update_url) || '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        updates: updates,
        sections: sections.map(function (section) {
          return section.section;
        }),
        sections_url: window.location.pathname,
      }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (parsedState) {
        if (parsedState.item_count === 0 && cartDrawer) {
          cartDrawer.classList.add('is-empty');
        }
        if (cartItems && typeof cartItems.getSectionInnerHTML === 'function') {
          cartItems.classList.toggle('is-empty', parsedState.item_count === 0);
          sections.forEach(function (section) {
            var elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) ||
              document.getElementById(section.id);
            if (!elementToReplace || !parsedState.sections || !parsedState.sections[section.section]) return;
            elementToReplace.innerHTML = cartItems.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          });
        } else if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(parsedState);
        }
      })
      .catch(function () {
        button.removeAttribute('aria-disabled');
        if (spinner) spinner.classList.add('hidden');
      });
  });
})();
